import { render, staticRenderFns } from "./BackLink.htm?vue&type=template&id=ee059970&scoped=true&"
import script from "./BackLink.ts?vue&type=script&lang=js&"
export * from "./BackLink.ts?vue&type=script&lang=js&"
import style0 from "./BackLink.scss?vue&type=style&index=0&id=ee059970&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee059970",
  null
  
)

export default component.exports